@import "../../globals/scss/label";
@import "stylesheets/sdx/utilities/screenreaders";

.component {
  // reset default fieldset styles
  border: none;
  margin: 0;
  padding: 0;

  .inline {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-content: stretch;
    gap: $baseline-4;

    &.input-container {
      gap: $baseline-2;
    }
  }
}
